import * as S from '@effect/schema/Schema';
export var ChatPageBlockConfig = S.struct({
  typename: S.literal('ChatPageBlock'),
  id: S.string,
  hash: S.string,
  messagingEnabled: S["boolean"]
});